<template>
    <div class="grid grid-cols-2 gap-2 sm:grid-cols-3 lg:grid-cols-4">
        <button
            v-for="option in options"
            :key="option.id"
            type="button"
            class="relative flex min-h-[56px] items-center justify-center rounded-xl border px-3 py-3 text-center text-sm font-medium transition-all"
            :class="isSelected(option)
                ? 'border-cyan-600 bg-cyan-600 text-white shadow-sm'
                : 'border-gray-200 bg-white text-gray-600 hover:border-cyan-300 hover:bg-cyan-50'"
            @click="toggle(option)"
        >
            <svg v-if="isSelected(option)" class="absolute right-1.5 top-1.5 h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5">
                <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l6 6 9-13.5" />
            </svg>
            {{ option.label }}
        </button>
    </div>
</template>

<script>
import UtilService from '../services/UtilService';

export default {
    name: 'BodyPartPicker',
    props: {
        options: {
            type: Array,
            required: true
        },
        modelValue: {
            type: Array,
            default: () => []
        }
    },
    emits: ['update:modelValue'],
    setup(props, { emit }) {
        function isSelected(option) {
            return props.modelValue.some(item => item.label === option.label);
        }

        function toggle(option) {
            if (isSelected(option)) {
                emit('update:modelValue', props.modelValue.filter(item => item.label !== option.label));
                return;
            }

            emit('update:modelValue', [...props.modelValue, { label: option.label, id: UtilService.generateUUID() }]);
        }

        return { isSelected, toggle };
    }
}
</script>
